import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What is Davway Solutions?",
      answer: "Davway Solutions offers payment solutions through our official partner, Stackably. Stackably is an all-in-one platform for industry-specific POS and payment solutions. It bundles the tools, support, and pricing you need to launch fast and grow smart — without the tech headaches. Through this partnership, we provide payment systems and services to local businesses and contractors."
    },
    {
      question: "How is Stackably different from Square or Clover?",
      answer: "Unlike Square or Clover, Stackably offers a fully compliant dual pricing program that offsets the cost of payment processing — meaning you can eliminate your processing fees entirely. Each stack is tailored to your industry, so you get exactly what you need. Plus, you get real support from people who know your business."
    },
    {
      question: "Who can use our services?",
      answer: "Any business that accepts card payments can benefit from our services. We work with contractors, motels, salons, restaurants, auto shops, gyms, and any local business looking to eliminate processing fees and simplify their payment operations."
    },
    {
      question: "Is dual pricing legal and compliant?",
      answer: "Yes. Dual pricing is fully compliant with Visa, Mastercard, Amex, and Discover guidelines. It's also PCI DSS compliant with bank-level encryption. Our payment systems are configured to handle all compliance requirements automatically — you don't have to worry about a thing."
    },
    {
      question: "How do I get started?",
      answer: "It's simple: use our Profit Leak Calculator to see how much you're losing, schedule a quick no-pressure walkthrough with our team, and we'll ship a pre-configured payment system directly to your business. You can start processing same day — no complicated setup, no long contracts."
    },
    {
      question: "What kind of support is provided?",
      answer: "You get 24/7 real support from people who know your industry. Whether it's a technical question, a transaction issue, or help understanding your reports — our team is always ready to help when you need it."
    }
  ];

  return (
    <section className="py-20" style={{ backgroundColor: '#F8FAFC' }}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium mb-6" style={{ backgroundColor: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37' }}>
            <HelpCircle size={16} />
            <span>FAQ</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#0F172A' }}>
            Frequently Asked Questions <span style={{ color: '#D4AF37' }}>About Our Partner</span>
          </h2>
          <p className="text-lg text-gray-600">
            The details that make switching simple.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow"
              data-testid={`faq-item-${index}`}
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                data-testid={`faq-toggle-${index}`}
              >
                <span className="font-semibold text-lg" style={{ color: '#0F172A' }}>{faq.question}</span>
                <ChevronDown 
                  size={20} 
                  className={`flex-shrink-0 ml-4 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}
                  style={{ color: '#D4AF37' }}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96 pb-5' : 'max-h-0'}`}
              >
                <p className="px-6 text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
